import React from 'react';
import checkIcon from '../../../../../../assets/image/check_stock_icon.svg';
import closeIcon from '../../../../../../assets/image/close.svg';
import PageLoader from '../../../../../../component/PageLoader';

const CATEGORY_ORDER = [
	'Core',
	'Inventory',
	'Sales',
	'Purchases',
	'Integrations',
	'Automation',
	'Advanced Analytics',
];

const resolveFeatureDisplay = (item) => {
	if (item.is_unlimited || item.value === 'unlimited') {
		return { label: `Unlimited ${item.name}`, available: true };
	}
	if (item.value === true) return { label: item.name, available: true };
	if (item.value === false) return { label: item.name, available: false };
	if (typeof item.value === 'number')
		return { label: `${item.value} ${item.name}`, available: true };
	if (typeof item.value === 'string')
		return { label: `${item.value} ${item.name}`, available: true };
	return { label: item.name, available: false };
};

const deduplicateByKey = (items) => {
	const map = new Map();
	for (const item of items ?? []) {
		map.set(item.key, item);
	}
	return Array.from(map.values());
};

const sortedCategories = (features) => {
	const entries = Object.entries(features);
	const ordered = [];
	const remaining = [];

	for (const cat of CATEGORY_ORDER) {
		const found = entries.find(([key]) => key === cat);
		if (found) ordered.push(found);
	}

	for (const entry of entries) {
		if (!CATEGORY_ORDER.includes(entry[0])) remaining.push(entry);
	}

	return [...ordered, ...remaining];
};

export default function SubscriptionFeatures({ features, loader }) {
	return (
		<div>
			<div
				className="rounded-3 my-2"
				style={{
					border: '1px solid #ECEFF3',
					background: '#FCFCFD',
					boxShadow: '0 4px 20px rgba(0,0,0,.04)',
				}}
			>
				<div className="py-4 px-5">
					<div
						style={{
							fontSize: '22px',
							fontWeight: 700,
							color: '#222',
						}}
					>
						Plan Features
					</div>

					<div
						style={{
							color: '#777',
							fontSize: '14px',
							marginTop: 4,
						}}
					>
						Everything included in your current subscription.
					</div>
				</div>
				<div className="subscription-border" />

				{loader ? (
					<PageLoader />
				) : features ? (
					<div className="row g-3 px-4 pb-4 pt-4">
						{' '}
						{sortedCategories(features).map(([category, items], index) => {
							const uniqueItems = deduplicateByKey(items);

							return (
								<div
									className="col-xl-4 col-lg-6 col-12"
									key={index}
								>
									<div
										className="h-100 rounded-3 p-4"
										style={{
											background: '#FFFFFF',
											border: '1px solid #ECEFF3',
											boxShadow: '0 2px 8px rgba(16,24,40,0.04)',
										}}
									>
										<div
											className="d-flex justify-content-between align-items-center mb-4 pb-2"
											style={{
												borderBottom: '1px solid #F1F3F5',
											}}
										>
											<h5
												className="mb-0 fw-semibold"
												style={{
													fontSize: '17px',
													color: '#222',
												}}
											>
												{category}
											</h5>

											<span
												className="px-2 py-1 rounded-pill"
												style={{
													background: '#F8F9FA',
													fontSize: '12px',
													fontWeight: 600,
													color: '#666',
												}}
											>
												{uniqueItems.length}
											</span>
										</div>

										{uniqueItems.length > 0 ? (
											uniqueItems.map((item, i) => {
												const { available } = resolveFeatureDisplay(item);

												return (
													<div
														key={i}
														className="d-flex justify-content-between align-items-center py-2"
														style={{
															borderBottom:
																i !== uniqueItems.length - 1 ? '1px solid #F5F5F5' : 'none',
														}}
													>
														<div className="d-flex align-items-center gap-3">
															<img
																src={available ? checkIcon : closeIcon}
																alt=""
																width={18}
																height={18}
															/>

															<span
																style={{
																	fontSize: '14px',
																	color: '#444',
																	fontWeight: 500,
																}}
															>
																{item.name}
															</span>
														</div>

														{item.input_type !== 'boolean' && item.value !== null && (
															<span
																className="px-2 py-1 rounded-pill"
																style={{
																	background: available ? '#EEF9F1' : '#FDECEC',
																	color: available ? '#2E7D32' : '#DC3545',
																	fontSize: '12px',
																	fontWeight: 600,
																	whiteSpace: 'nowrap',
																}}
															>
																{item.is_unlimited || item.value === 'unlimited'
																	? 'Unlimited'
																	: item.value}
															</span>
														)}
													</div>
												);
											})
										) : (
											<div
												className="text-center py-4"
												style={{
													color: '#888',
													fontSize: '14px',
												}}
											>
												No features available in this category.
											</div>
										)}
									</div>
								</div>
							);
						})}
					</div>
				) : (
					<div
						className="text-center py-4"
						style={{
							color: '#888',
							fontSize: '14px',
						}}
					>
						No features available in this category.
					</div>
				)}
			</div>
		</div>
	);
}
